import React from 'react';

import './styles.css';

const Header = () => <header>Image Gallery!</header>;

export default Header;
